import _extends from 'babel-runtime/helpers/extends';

import { mapState } from 'vuex';
import _ from 'lodash';
import gameIframe from '@ps/bridge/iframe/iframe';

export default {
  props: {
    config: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    this.x = _.get(this.model, this.config.prop + '.x');
    this.y = _.get(this.model, this.config.prop + '.y');
  },
  data: function data() {
    return {
      x: 0,
      y: 0
    };
  },

  computed: _extends({}, mapState({
    activeNode: function activeNode(state) {
      return state.workspace.game.activeNode;
    }
  })),
  methods: {
    realProp: function realProp() {
      var index = this.config.prop.lastIndexOf('.');
      if (index === -1) {
        return this.config.prop;
      }
      return this.config.prop.slice(0, index);
    },
    setPointValue: function setPointValue() {
      this.x = this.activeNode.anchoredX;
      this.y = this.activeNode.anchoredY;
      var prop = this.realProp();
      _.set(this.model.script, prop, new gameIframe.qc.Point(Number(this.x), Number(this.y)));
      _.set(this.model, this.config.prop + '.x', Number(this.x));
      _.set(this.model, this.config.prop + '.y', Number(this.y));
    },
    changeX: function changeX(v) {
      var prop = this.realProp();
      _.set(this.model.script, prop, new gameIframe.qc.Point(Number(v), Number(this.y)));
      _.set(this.model, this.config.prop + '.x', Number(this.x));
    },
    changeY: function changeY(v) {
      var prop = this.realProp();
      _.set(this.model.script, prop, new gameIframe.qc.Point(Number(this.x), Number(v)));
      _.set(this.model, this.config.prop + '.y', Number(this.y));
    }
  }
};